import { render, staticRenderFns } from "./ProjectBuildings.vue?vue&type=template&id=15ef0de4&scoped=true"
import script from "./ProjectBuildings.vue?vue&type=script&lang=ts"
export * from "./ProjectBuildings.vue?vue&type=script&lang=ts"
import style0 from "./ProjectBuildings.vue?vue&type=style&index=0&id=15ef0de4&prod&lang=scss&scoped=true"
import style1 from "./ProjectBuildings.vue?vue&type=style&index=1&id=15ef0de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef0de4",
  null
  
)

export default component.exports